import { createApi } from '@reduxjs/toolkit/query/react';
import { newBackendAxiosBaseQuery } from '../../utils/axiosBaseQuery';
import { serializeQueryArgsWithTenant } from '../tenantCacheKey';

// The dashboard's "Today and tomorrow" figures (#3016) —
// GET /admin/dashboard/day-summary on the new (ECS) backend. The base query
// carries `/admin`, so the slice path starts at `/dashboard`.

/** One day's aggregated counts. */
export interface DayFigures {
    /** Bookings whose start falls on the day at their location. */
    starting: number;
    /** Bookings whose end falls on the day at their location. */
    ending: number;
    /** Of those starting, the room reservations still awaiting approval. */
    awaitingApproval: number;
}

export interface DaySummaryResponse {
    today: DayFigures;
    tomorrow: DayFigures;
}

export interface GetDaySummaryArgs {
    /** The use cases the bookings list shows (`config.services`), so figure and list cover the same rows. */
    useCases: string[];
}

export const dashboardApiSlice = createApi({
    reducerPath: 'dashboardApiSlice',
    serializeQueryArgs: serializeQueryArgsWithTenant,
    baseQuery: newBackendAxiosBaseQuery(),
    tagTypes: ['DaySummary'],
    endpoints: (builder) => ({
        getDaySummary: builder.query<DaySummaryResponse, GetDaySummaryArgs>({
            query: ({ useCases }) => ({
                url: `/dashboard/day-summary?${new URLSearchParams({ useCases: useCases.join(',') }).toString()}`,
                method: 'GET',
            }),
            providesTags: ['DaySummary'],
        }),
    }),
});

export const { useGetDaySummaryQuery } = dashboardApiSlice;
